import DOMPurify from 'dompurify';

// Defense-in-depth XSS sanitization for dangerouslySetInnerHTML usage.
// Backend sanitization (Rails simple_format, Commonmarker 2.x) is the primary
// defense; this is a secondary frontend layer.
//
// Allowlist covers content produced by:
// - Rails simple_format: p, br, strong, em, a
// - Commonmarker markdown: headings, lists, code blocks, blockquotes, tables, images
// - CMS/admin-authored rich text: tables, figures, sub/sup
//
// Keep in sync with: enterprise/src/utils/sanitizeHtml.ts, platform3/src/Utils/sanitizeHtml.ts
// Related: DVLP-7183, DVLP-7242, Aikido XSS audit
const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'u',
  's',
  'a',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'code',
  'pre',
  'blockquote',
  'span',
  'div',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'img',
  'figure',
  'figcaption',
  'hr',
  'sub',
  'sup',
];

const ALLOWED_ATTR = [
  'href',
  'src',
  'alt',
  'title',
  'target',
  'rel',
  'class',
  'id',
  'width',
  'height',
  'colspan',
  'rowspan',
];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
});

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}
